import { render, staticRenderFns } from "./InputComments.vue?vue&type=template&id=abc3fee8"
import script from "./InputComments.vue?vue&type=script&lang=js"
export * from "./InputComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports